module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTk2IDE5Mmg4MzJhMzIgMzIgMCAwIDEgMzIgMzJ2NTc2YTMyIDMyIDAgMCAxLTMyIDMySDk2YTMyIDMyIDAgMCAxLTMyLTMyVjIyNGEzMiAzMiAwIDAgMSAzMi0zMnoiIGZpbGw9IiMwIiBwLWlkPSIzOTMxIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Rectangle-filled.svg
// module id = UgfI
// module chunks = 74